module.exports = __webpack_public_path__ + "img/img_throw_2@3x.7d223686.png";